import { render, staticRenderFns } from "./MarketIndices.vue?vue&type=template&id=047ddf59&"
import script from "./MarketIndices.vue?vue&type=script&lang=js&"
export * from "./MarketIndices.vue?vue&type=script&lang=js&"
import style0 from "./MarketIndices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports